import api from './Core/api';
import { ServiceDefinition } from './defaultServices';

export const checkIfServiceAvailable = (serviceName: string): boolean => {
  const availableServices = api.getAvailableSiteServices() as ServiceDefinition[];
  return availableServices?.some((x) => x.name.toLowerCase() === serviceName.toLowerCase());
};
